import { EventHandler } from './helpers';

export const ToastEventHandler = new EventHandler();
